import React, { useEffect } from 'react';
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import { useApplicationContext } from '../../application/ApplicationContext';
import './RegistrationOverviewPage.scss';

const RegistrationOverviewPage = () => {

    const { setBreadcrumb } = useApplicationContext();

    useEffect(() => {
        setBreadcrumb(['Prijave', 'Lista prijava', 'Danka Maksimovic']); //todo: set dinamic based at id
    }, []);

    return (
        <PageLayout>
            <div className="registration-overview">
                PREGLED PODATAKA O PRIJAVI
            </div>
        </PageLayout>
    );
};

export default RegistrationOverviewPage;
